import { ctaDesc, ctaTitle } from "@/lib/seo";
import { createFileRoute, notFound } from "@tanstack/react-router";
import NaatiProductPage from "@/components/NaatiProductPage";
import { naatiProductGraph, defaultProductFaqs } from "@/lib/naati-product-schema";
import { BRAND_URL } from "@/lib/brand";

export const Route = createFileRoute("/en/naati/products/$sku")({
  loader: async ({ params }) => {
    const { getNaatiProduct } = await import("@/data/naati-products");
    const p = getNaatiProduct(params.sku);
    if (!p) throw notFound();
    return { product: p };
  },
  head: ({ loaderData, params }) => {
    if (!loaderData) return { meta: [{ title: ctaTitle("Product not found", "/en/naati/products/$sku", "en")}, { name: "robots", content: "noindex" }] };
    const p = loaderData.product;
    const path = `/en/naati/products/${params.sku}`;
    const url = `${BRAND_URL}${path}`;
    const title = `NAATI ${p.nameEn} Translation — Certified for Australia | 5–7 days`;
    const desc = p.shortDescEn + " · Certified by NAATI CPN translator + Thai attorney reviewed before every stamp.";
    const faqs = defaultProductFaqs(p, "en");
    return {
      meta: [
        { title: ctaTitle(title, "/en/naati/products/$sku", "en") }, { name: "description", content: ctaDesc(desc, "/en/naati/products/$sku", "en")},
        { property: "og:title", content: ctaTitle(title, "/en/naati/products/$sku", "en")},
        { property: "og:description", content: ctaDesc(desc, "/en/naati/products/$sku", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "product" },
        { property: "og:locale", content: "en_US" },
        { property: "product:price:amount", content: "1900" },
        { property: "product:price:currency", content: "THB" },
      ],
      links: [
        { rel: "canonical", href: url },
        { rel: "alternate", hrefLang: "en", href: url },
        { rel: "alternate", hrefLang: "th-TH", href: `${BRAND_URL}/naati/products/${params.sku}` },
        { rel: "alternate", hrefLang: "x-default", href: `${BRAND_URL}/naati/products/${params.sku}` },
      ],
      scripts: [{
        type: "application/ld+json",
        children: JSON.stringify(naatiProductGraph({ product: p, locale: "en", path, faqs })),
      }],
    };
  },
  notFoundComponent: () => <div className="p-16 text-center">Product not found</div>,
  component: () => {
    const { product } = Route.useLoaderData();
    return <NaatiProductPage product={product} locale="en" faqs={defaultProductFaqs(product, "en")} />;
  },
});
